import React, { useState } from 'react';
import ConfirmModal from './ConfirmModal.js';
import Footer from '../Footer/Footer.js';
import { Helmet } from 'react-helmet-async';

import { personal_training, metabolic_testing, nutrition_sessions } from '../../assets/individual_items.js';

const Individual = (props) => {

    const context = props.context

    // console.log("****Packages.js - context", context)

    const [modalIsOpen,setIsOpen] = useState(false);
    const [newItem, setNewItem] = useState({});

    async function openModal() {
        setIsOpen(true);
    }

    function closeModal(){
        setIsOpen(false);
    }

    const addToCart = async function(e, item){
        e.preventDefault()
        setNewItem(item)
        let addItem = {
            ...item,
            quantity: 1
        }
        context.actions.addToCart(addItem)
        openModal();
    }

    return (
            <div className="container-page" id="individual">
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="description" content="It's A Good Life Fitness" />
                    <title>It's A Good Life Fitness | Individual Sessions</title>
                    <link rel="canonical" href="https://itsagoodlifefitness.com" />
                </Helmet>
                <div className="packages-header">
                    <h1 role="main">Individual Sessions</h1>
                </div>

                <div className="individual-container" id="individual">
                    
                    <div className="individual-item-container">
                        <div className="individual-item-header">
                            <h2>Personal Training</h2>
                        </div>
                        {personal_training.map((item, index) =>{
                            return(
                                <div className={`item-${index + 1}`} key={index}>
                                    <div className="item-desc">
                                        <div className="name">{item.name}</div>
                                        <div className="description"><p>{item.long_description}</p></div>
                                    </div>
                                    <div className="individual-column">
                                        <div className="price">${item.price}</div>
                                        <button className="button" onClick={(e) => addToCart(e, item)}>Add To Cart</button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="individual-item-container">
                        <div className="individual-item-header">
                            <h2>Metabolic Testing</h2>
                        </div>
                        {metabolic_testing.map((item, index) =>{
                            return(
                                <div className={`item-${index + 2}`} key={index}>
                                    <div className="item-desc">
                                        <div className="name">{item.name}</div>
                                        <div className="description"><p>{item.long_description}</p></div>
                                    </div>
                                    <div className="individual-column">
                                        <div className="price">${item.price}</div>
                                        <button className="button" onClick={(e) => addToCart(e, item)}>Add To Cart</button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="individual-item-container">
                        <div className="individual-item-header">
                            <h2>Nutrition Session</h2>
                        </div>
                        {nutrition_sessions.map((item, index) =>{
                            return(
                                <div className={`item-${index + 4}`} key={index}>
                                    <div className="item-desc">
                                        <div className="name">{item.name}</div>
                                        <div className="description"><p>{item.long_description}</p></div>
                                    </div>
                                    <div className="individual-column" id={`column-${index + 4}`}>
                                        <div className="price">${item.price}</div>
                                        <button className="button" onClick={(e) => addToCart(e, item)}>Add To Cart</button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                </div>
                <ConfirmModal modalIsOpen={modalIsOpen} closeModal={closeModal} newItem={newItem} context={context} props={props} />
                <Footer {...props} />
            </div>
    )
}

export default Individual;